import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValuesInLettersService {

  constructor() { }

  // Notas:  Math.trunc() se utiliza para obtener la parte entera de un número, eliminando cualquier fracción decimal.

  convertNumberToLetters(value: number, includeCents: boolean): string {
    let valueInLetters: string = '';
    let numberToLetters: string = '';
    let cents: string = '';
    let millions: string = '';
    let thousands: string = '';
    let units: string = '';
    let number: number = 0;
    let numberThousands: number = 0;
    let valueCents: number = 0;
    let totalDigits: number = 0;

    if (includeCents) {
      valueCents = (value - Math.trunc(value)) * 100;
      cents = ` CON ${String(valueCents).substring(0, 2)} CVS.`;
      totalDigits = totalDigits + 12;
    } else {
      value = Math.round(value);
    }

    value = Math.trunc(value);
    if (value > 999999999) return valueInLetters;

    // Trabaja para millones
    number = Math.trunc(value / 1000000);
    numberToLetters = this.getLetters(number, totalDigits);
    millions = numberToLetters;
    numberThousands = value - number * 1000000;

    // Trabaja para miles
    number = Math.trunc(numberThousands / 1000);
    numberToLetters = this.getLetters(number, totalDigits);
    thousands = numberToLetters;

    // Trabaja para unidades
    number = numberThousands - number * 1000;
    numberToLetters = this.getLetters(number, totalDigits);
    units = numberToLetters;

    // Define la numberToLetters
    if (number > 0) numberToLetters = units;

    if (Math.trunc(numberThousands / 1000) > 0) {
      numberToLetters = `${thousands} MIL ${numberToLetters}`;
      totalDigits = totalDigits + 5;
    }

    if (Math.trunc(value / 1000000) > 1) {
      numberToLetters = `${millions} MILLONES ${numberToLetters}`;
      totalDigits = totalDigits + 10;
    }

    if (Math.trunc(value / 1000000) === 1) {
      numberToLetters = `${millions} MILLON ${numberToLetters}`;
      totalDigits = totalDigits + 7;
    }

    if (value / 1000000 === Math.trunc(value / 1000000)) {
      numberToLetters = `${numberToLetters} DE PESOS M/L${cents}`;
      totalDigits = totalDigits + 13;
    } else {
      numberToLetters = `${numberToLetters} PESOS M/L${cents}`;
      totalDigits = totalDigits + 10;
    }

    if (value === 0) {
      numberToLetters = "CERO PESOS M/L";
      totalDigits = totalDigits + 17;
    } else if (value === 1) {
      numberToLetters = "UN PESO M/L";
      totalDigits = totalDigits + 14;
    }

    totalDigits = numberToLetters.length;
    totalDigits = 120 - totalDigits;
    numberToLetters = numberToLetters + "*".repeat(5);
    valueInLetters = numberToLetters;

    return valueInLetters;
  }

  getLetters(number: number, totalDigits: number): string {
    let numberInLetters: string = '';
    let hundredsInLetters: string = '';
    let unitsInLetters: string = '';
    let hundreds: number = 0;
    let tens: number = 0;
    let units: number = 0;

    // Calcula valores base
    hundreds = Math.trunc(number / 100);
    tens = Math.trunc((number - hundreds * 100) / 10);
    units = (number - hundreds * 100) - (tens * 10);

    // Trabaja con los valores centenas
    switch (hundreds) {
      case 1:
        hundredsInLetters = "CIENTO";
        totalDigits = totalDigits + 6;
        break;
      case 2:
        hundredsInLetters = "DOSCIENTOS";
        totalDigits = totalDigits + 10;
        break;
      case 3:
        hundredsInLetters = "TRESCIENTOS";
        totalDigits = totalDigits + 11;
        break;
      case 4:
        hundredsInLetters = "CUATROCIENTOS";
        totalDigits = totalDigits + 13;
        break;
      case 5:
        hundredsInLetters = "QUINIENTOS";
        totalDigits = totalDigits + 10;
        break;
      case 6:
        hundredsInLetters = "SEISCIENTOS";
        totalDigits = totalDigits + 11;
        break;
      case 7:
        hundredsInLetters = "SETECIENTOS";
        totalDigits = totalDigits + 11;
        break;
      case 8:
        hundredsInLetters = "OCHOCIENTOS";
        totalDigits = totalDigits + 11;
        break;
      case 9:
        hundredsInLetters = "NOVECIENTOS";
        totalDigits = totalDigits + 11;
        break;
    }

    // Trabaja con los valores unidad
    switch (units) {
      case 0:
        unitsInLetters = " ";
        totalDigits = totalDigits + 1;
        break;
      case 1:
        unitsInLetters = "UN";
        totalDigits = totalDigits + 2;
        break;
      case 2:
        unitsInLetters = "DOS";
        totalDigits = totalDigits + 3;
        break;
      case 3:
        unitsInLetters = "TRES";
        totalDigits = totalDigits + 4;
        break;
      case 4:
        unitsInLetters = "CUATRO";
        totalDigits = totalDigits + 6;
        break;
      case 5:
        unitsInLetters = "CINCO";
        totalDigits = totalDigits + 5;
        break;
      case 6:
        unitsInLetters = "SEIS";
        totalDigits = totalDigits + 4;
        break;
      case 7:
        unitsInLetters = "SIETE";
        totalDigits = totalDigits + 5;
        break;
      case 8:
        unitsInLetters = "OCHO";
        totalDigits = totalDigits + 4;
        break;
      case 9:
        unitsInLetters = "NUEVE";
        totalDigits = totalDigits + 5;
        break;
    }

    // Crea la unión Y
    if (units > 0 && tens > 0) {
      unitsInLetters = ` Y ${unitsInLetters}`;
    }

    // Trabaja con los valores decenas
    switch (tens) {
      case 1:
        unitsInLetters = `DIEZ${unitsInLetters}`;
        totalDigits = totalDigits + 4;
        break;
      case 2:
        unitsInLetters = `VEINTE${unitsInLetters}`;
        totalDigits = totalDigits + 6;
        break;
      case 3:
        unitsInLetters = `TREINTA${unitsInLetters}`;
        totalDigits = totalDigits + 7;
        break;
      case 4:
        unitsInLetters = `CUARENTA${unitsInLetters}`;
        totalDigits = totalDigits + 8;
        break;
      case 5:
        unitsInLetters = `CINCUENTA${unitsInLetters}`;
        totalDigits = totalDigits + 9;
        break;
      case 6:
        unitsInLetters = `SESENTA${unitsInLetters}`;
        totalDigits = totalDigits + 7;
        break;
      case 7:
        unitsInLetters = `SETENTA${unitsInLetters}`;
        totalDigits = totalDigits + 7;
        break;
      case 8:
        unitsInLetters = `OCHENTA${unitsInLetters}`;
        totalDigits = totalDigits + 7;
        break;
      case 9:
        unitsInLetters = `NOVENTA${unitsInLetters}`;
        totalDigits = totalDigits + 7;
        break;
    }

    // Trabaja con las excepciones
    if (tens * 10 + units === 11) {
      unitsInLetters = "ONCE";
      totalDigits = totalDigits + 4;
    } else if (tens * 10 + units === 12) {
      unitsInLetters = "DOCE";
      totalDigits = totalDigits + 4;
    } else if (tens * 10 + units === 13) {
      unitsInLetters = "TRECE";
      totalDigits = totalDigits + 5;
    } else if (tens * 10 + units === 14) {
      unitsInLetters = "CATORCE";
      totalDigits = totalDigits + 7;
    } else if (tens * 10 + units === 15) {
      unitsInLetters = "QUINCE";
      totalDigits = totalDigits + 6;
    } else if (tens * 10 + units === 16) {
      unitsInLetters = "DIECISEIS";
      totalDigits = totalDigits + 9;
    } else if (tens * 10 + units === 17) {
      unitsInLetters = "DIECISIETE";
      totalDigits = totalDigits + 10;
    } else if (tens * 10 + units === 18) {
      unitsInLetters = "DIECIOCHO";
      totalDigits = totalDigits + 9;
    } else if (tens * 10 + units === 19) {
      unitsInLetters = "DIECINUEVE";
      totalDigits = totalDigits + 10;
    } else if (tens * 10 + units === 21) {
      unitsInLetters = "VEINTIÚN";
      totalDigits = totalDigits + 8;
    } else if (tens * 10 + units === 22) {
      unitsInLetters = "VEINTIDOS";
      totalDigits = totalDigits + 9;
    } else if (tens * 10 + units === 23) {
      unitsInLetters = "VEINTITRES";
      totalDigits = totalDigits + 10;
    } else if (tens * 10 + units === 24) {
      unitsInLetters = "VEINTICUATRO";
      totalDigits = totalDigits + 12;
    } else if (tens * 10 + units === 25) {
      unitsInLetters = "VEINTICINCO";
      totalDigits = totalDigits + 11;
    } else if (tens * 10 + units === 26) {
      unitsInLetters = "VEINTISEIS";
      totalDigits = totalDigits + 10;
    } else if (tens * 10 + units === 27) {
      unitsInLetters = "VEINTISIETE";
      totalDigits = totalDigits + 11;
    } else if (tens * 10 + units === 28) {
      unitsInLetters = "VEINTIOCHO";
      totalDigits = totalDigits + 10;
    } else if (tens * 10 + units === 29) {
      unitsInLetters = "VEINTINUEVE";
      totalDigits = totalDigits + 11;
    }

    // Trabaja con todo el número
    if (number === 0) {
      numberInLetters = "";
      totalDigits = totalDigits + 1;
    } else if (number === 1) {
      numberInLetters = "UN";
      totalDigits = totalDigits + 2;
    } else if (number === 100) {
      numberInLetters = "CIEN";
      totalDigits = totalDigits + 4;
    } else if (number < 100) {
      numberInLetters = unitsInLetters as string;
    } else if (number > 100) {
      numberInLetters = `${hundredsInLetters} ${unitsInLetters}`;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      totalDigits = totalDigits + 1;
    }

    numberInLetters = numberInLetters.trim();
    return numberInLetters;
  }

}
